import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { PedidoAnexo } from '../models/pedido-anexo';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class PedidoAnexoService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarPedidoAnexos() {
    return this.http.get<PedidoAnexo[]>(globals.apiUrl + '/api/PedidoAnexo/Lista');
  }

  possuiAnexoDeIntegrador(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoAnexo/PossuiAnexoDeIntegrador',
      { params: new HttpParams().set('idCupom', idCupom) });
  }

  // PossuiAnexoDeIntegrador

  consultarPedidoAnexosComPaginacao(idCupom, descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, origem) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('origem', origem)
      .set('idCupom', idCupom);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/PedidoAnexo/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdPedidoAnexo(id) {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoAnexo/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(pedidoAnexo) {
    return this.http.post(globals.apiUrl + '/api/PedidoAnexo/Salvar', pedidoAnexo);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/PedidoAnexo/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
